import Loadable from 'react-loadable';
const TeamProfilePage = Loadable({
  loader: () => import( /* webpackChunkName: "async-ptc_team-profile-page" */'./TeamProfileContainer'),
  loading: () => null
});
TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
export default TeamProfilePage;